module.exports = __webpack_public_path__ + "img/26.9705509a.png";